module.exports = __webpack_public_path__ + "media/customizations/default/spinner-tertiary-413e76b48ce59976b2778bf3af31e9c1.gif";